import { images } from "../../../Assets/assetsHelper";
import "./Profile.css";
import React, { useState } from "react";
import FormModal from "../../../Components/Molecules/FormModal/FormModal";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { PulseLoader } from "react-spinners";
import PrimaryButton from "../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import { BaseURL } from "../../../Hooks/URL";
import { Fetch } from "../../../Hooks/Fetch";
import config from "../../../config";

function Profile({ Open, setOpen, profile, loading }) {
  const navigate = useNavigate();
  return (
    <div className="mainContainer">
      <FormModal
        Open={Open}
        HandleClose={() => {
          setOpen(false);
        }}
        Form={<></>}
        Title={"Edit Profile"}
      />
      {!loading ? (
        <div className="ProfileCont">
          <div className="greyBoxVer">
            <Typography
              sx={{
                fontSize: { xs: "20px", md: "22px" },
                fontWeight: "600",
                marginBottom: "4px",
              }}
            >
              Registration Progress
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "14px", md: "16px" },
                fontWeight: "400",
                marginBottom: "20px",
              }}
            >
              This is your central hub for managing registrations in the{" "}
              <strong>
                {config.APP_NAME == "Code Reg"
                  ? "Code Challenge Competition"
                  : config.APP_NAME == "WeDo Reg"
                  ? "WeDo Challenge Competition"
                  : "International Robot Challenge Competition"}
              </strong>
              . From here, you can efficiently oversee your teams, participants,
              coaches, and payments. Navigate the system with ease and ensure a
              smooth registration process for your organization.
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {/* Step 1: Create Account */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Box
                  sx={{
                    width: 30,
                    height: 30,
                    borderRadius: "50%",
                    backgroundColor: "success.main",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  ✓
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography
                    sx={{
                      fontSize: { xs: "16px", md: "18px" },
                      fontWeight: "500",
                    }}
                  >
                    Create Account
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: { xs: "14px", md: "16px" },
                      color: "text.secondary",
                    }}
                  >
                    You've successfully created your account and are ready to
                    start your journey!
                  </Typography>
                </Box>
              </Box>

              {/* Step 2: Add Team */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    width: 30,
                    height: 30,
                    borderRadius: "50%",
                    backgroundColor:
                      profile?.details?.teamsCount > 0
                        ? "success.main"
                        : "grey.300",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate("/teams/add")}
                >
                  {profile?.details?.teamsCount > 0 ? "✓" : "2"}
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography
                    sx={{
                      fontSize: { xs: "16px", md: "18px" },
                      fontWeight: "500",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={() => navigate("/teams/add")}
                  >
                    Add Your Team
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: { xs: "14px", md: "16px" },
                      color: "text.secondary",
                      mb: 0.5,
                    }}
                  >
                    {profile?.details?.teamsCount > 0
                      ? `Great job! You've added ${
                          profile?.details?.teamsCount
                        } team${profile?.details?.teamsCount > 1 ? "s" : ""}.`
                      : "Start by adding your team members to participate in the competition."}
                  </Typography>
                </Box>
              </Box>

              {/* Step 3: Pay Registration Fees */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Box
                  sx={{
                    width: 30,
                    height: 30,
                    borderRadius: "50%",
                    backgroundColor: profile?.details?.paid
                      ? "success.main"
                      : "grey.300",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontWeight: "bold",
                    cursor:
                      profile?.details?.teamsCount > 0 ? "pointer" : "default",
                  }}
                  onClick={() => {
                    if (profile?.details?.teamsCount > 0)
                      navigate("/transactions");
                  }}
                >
                  {profile?.details?.paid ? "✓" : "3"}
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography
                    sx={{
                      fontSize: { xs: "16px", md: "18px" },
                      fontWeight: "500",
                      cursor:
                        profile?.details?.teamsCount > 0
                          ? "pointer"
                          : "default",
                      textDecoration:
                        profile?.details?.teamsCount > 0 ? "underline" : "none",
                    }}
                    onClick={() => {
                      if (profile?.details?.teamsCount > 0)
                        navigate("/transactions");
                    }}
                  >
                    Complete Payment
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: { xs: "14px", md: "16px" },
                      color: "text.secondary",
                    }}
                  >
                    {profile?.details?.paid
                      ? "Payment completed successfully! You're all set."
                      : "Secure your spot by completing the registration payment through our system or Instapay."}
                  </Typography>
                </Box>
              </Box>

              {/* Step 4: Join Competition */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Box
                  sx={{
                    width: 30,
                    height: 30,
                    borderRadius: "50%",
                    backgroundColor:
                      profile?.competitionStatus === "joined"
                        ? "success.main"
                        : "grey.300",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  {profile?.competitionStatus === "joined" ? "✓" : "4"}
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography
                    sx={{
                      fontSize: { xs: "16px", md: "18px" },
                      fontWeight: "500",
                    }}
                  >
                    Join the Competition
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: { xs: "14px", md: "16px" },
                      color: "text.secondary",
                    }}
                  >
                    {profile?.competitionStatus === "joined"
                      ? "You're officially part of the competition! Get ready to showcase your skills."
                      : "Final step! Join the competition and get ready for an exciting challenge."}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </div>

          <div className="greyBoxVer">
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: { xs: "column", md: "row" },
                alignItems: { xs: "flex-start", md: "center" },
                marginBottom: "10px",
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "20px", md: "22px" },
                  fontWeight: "600",
                }}
              >
                {profile?.type == "organization" ? "Admin" : "Team Leader"}{" "}
                Profile:
              </Typography>
              <a
                target="_blank"
                href={`${BaseURL}/account/dashboard/home/pdf?timeZone=${
                  Intl.DateTimeFormat().resolvedOptions().timeZone ??
                  "Africa/Cairo"
                }`}
              >
                <PrimaryButton
                  classBtn={"center"}
                  btnType={"submit"}
                  text={"Download Account PDF"}
                  style={{
                    textTransform: "capitalize",
                    minWidth: "230px",
                    borderRadius: "5px",
                    color: config.SECONDARY_COLOR,
                    backgroundColor: config.PRIMARY_COLOR,
                    marginRight: "5px",
                  }}
                />
              </a>
            </Box>
            <Typography
              sx={{
                fontSize: { xs: "17px", md: "20px" },
                fontWeight: "500",
                marginTop: "10px",
              }}
            >
              Name:{" "}
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "20px" },
                  fontWeight: "400",
                  marginTop: "10px",
                  display: "inline",
                }}
              >
                {profile?.admin?.name}
              </Typography>
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "17px", md: "20px" },
                fontWeight: "500",
                marginTop: "10px",
              }}
            >
              Email:{" "}
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "20px" },
                  fontWeight: "400",
                  marginTop: "10px",
                  display: "inline",
                }}
              >
                {profile?.admin?.email}
              </Typography>
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "17px", md: "20px" },
                fontWeight: "500",
                marginTop: "10px",
              }}
            >
              Phone Number:{" "}
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "20px" },
                  fontWeight: "400",
                  marginTop: "10px",
                  display: "inline",
                }}
              >
                {profile?.admin?.contactNumber}
              </Typography>
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "17px", md: "20px" },
                fontWeight: "500",
                marginTop: "10px",
              }}
            >
              Account Code:{" "}
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "20px" },
                  fontWeight: "400",
                  marginTop: "10px",
                  display: "inline",
                }}
              >
                {profile?.code}
              </Typography>
            </Typography>
            {profile?.personalAccountInfo ? (
              <Typography
                sx={{
                  fontSize: { xs: "17px", md: "20px" },
                  fontWeight: "500",
                  marginTop: "10px",
                }}
              >
                Country/City:{" "}
                <Typography
                  sx={{
                    fontSize: { xs: "16px", md: "20px" },
                    fontWeight: "400",
                    marginTop: "10px",
                    display: "inline",
                  }}
                >
                  {profile?.personalAccountInfo?.country}/
                  {profile?.personalAccountInfo?.city}
                </Typography>
              </Typography>
            ) : (
              ""
            )}
          </div>
          {profile?.type == "organization" ? (
            <div className="greyBoxVer">
              <Typography
                sx={{
                  fontSize: { xs: "20px", md: "22px" },
                  fontWeight: "600",
                  marginBottom: "10px",
                }}
              >
                Organization Details:
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "17px", md: "20px" },
                  fontWeight: "500",
                  marginTop: "10px",
                }}
              >
                Name:{" "}
                <Typography
                  sx={{
                    fontSize: { xs: "16px", md: "20px" },
                    fontWeight: "400",
                    marginTop: "10px",
                    display: "inline",
                  }}
                >
                  {profile?.organization?.name}
                </Typography>
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "17px", md: "20px" },
                  fontWeight: "500",
                  marginTop: "10px",
                }}
              >
                Phone Number:{" "}
                <Typography
                  sx={{
                    fontSize: { xs: "16px", md: "20px" },
                    fontWeight: "400",
                    marginTop: "10px",
                    display: "inline",
                  }}
                >
                  {profile?.organization?.branch?.contactNumber}
                </Typography>
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "17px", md: "20px" },
                  fontWeight: "500",
                  marginTop: "10px",
                }}
              >
                Country:{" "}
                <Typography
                  sx={{
                    fontSize: { xs: "16px", md: "20px" },
                    fontWeight: "400",
                    marginTop: "10px",
                    display: "inline",
                  }}
                >
                  {profile?.organization?.branch?.country}
                </Typography>
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "17px", md: "20px" },
                  fontWeight: "500",
                  marginTop: "10px",
                }}
              >
                Governorate:{" "}
                <Typography
                  sx={{
                    fontSize: { xs: "16px", md: "20px" },
                    fontWeight: "400",
                    marginTop: "10px",
                    display: "inline",
                  }}
                >
                  {profile?.organization?.branch?.city}
                </Typography>
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "17px", md: "20px" },
                  fontWeight: "500",
                  marginTop: "10px",
                }}
              >
                Address:{" "}
                <Typography
                  sx={{
                    fontSize: { xs: "16px", md: "20px" },
                    fontWeight: "400",
                    marginTop: "10px",
                    display: "inline",
                  }}
                >
                  {profile?.organization?.branch?.address}
                </Typography>
              </Typography>
            </div>
          ) : (
            ""
          )}

          <div className="greyBoxVer">
            {/* <Typography
              sx={{
                color: "primary.main",
                fontSize: { xs: "28px", md: "35px" },
                fontWeight: "500",
                marginBottom: "10px",
              }}
            >
              Welcome {profile?.admin?.name}!
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "14px", md: "16px" },
              }}
            >
              This is your central hub for managing registrations in the{" "}
              <strong>
                {config.APP_NAME == "Code Reg"
                  ? "Code Challenge Competition"
                  : "WeDo Challenge Competition"}
              </strong>
              . From here, you can efficiently oversee your teams, participants,
              coaches, and payments. Navigate the system with ease and ensure a
              smooth registration process for your organization.
            </Typography> */}

            <Typography
              sx={{
                fontSize: { xs: "16px", md: "20px" },
                fontWeight: "600",
              }}
            >
              Need Assistance?
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "14px", md: "16px" },
              }}
            >
              For technical issues or system-related questions, reach out to{" "}
              {config.APP_NAME == "Code Reg" ? (
                <a
                  href="mailto:support@codechallenge-championship.org"
                  style={{ textDecoration: "underline" }}
                >
                  support@codechallenge-championship.org
                </a>
              ) : config.APP_NAME == "WeDo Reg" ? (
                <a
                  href="mailto:support@wedochallenge.org"
                  style={{ textDecoration: "underline" }}
                >
                  support@wedochallenge.org
                </a>
              ) : (
                <a
                  href="mailto:Internationalrobotchallenge1@gmail.com"
                  style={{ textDecoration: "underline" }}
                >
                  Internationalrobotchallenge1@gmail.com
                </a>
              )}
            </Typography>
          </div>
        </div>
      ) : (
        <div className="loadingBox">
          <PulseLoader color={config.PRIMARY_COLOR} />
        </div>
      )}
    </div>
  );
}

export default Profile;
